export const SCORE_PLACEHOLDER = '--' as const

type MaybeFactorScore = Partial<ProjectModels.FactorScore> | null | undefined

export interface SafeFactorScore {
  score?: number
  meanScore?: number
  displayScore: number | typeof SCORE_PLACEHOLDER
  displayMeanScore: number | typeof SCORE_PLACEHOLDER
  isComparable: boolean
}

export function getSafeFactorScore(factorScore: MaybeFactorScore): SafeFactorScore {
  const score = typeof factorScore?.score === 'number' ? factorScore.score : undefined
  const meanScore = typeof factorScore?.meanScore === 'number' ? factorScore.meanScore : undefined
  return {
    score,
    meanScore,
    displayScore: score ?? SCORE_PLACEHOLDER,
    displayMeanScore: meanScore ?? SCORE_PLACEHOLDER,
    isComparable: score !== undefined && meanScore !== undefined,
  }
}
